import React from 'react';

function AppCrashFallback({ error }) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Something went wrong</h1>
      <p>We&apos;ve been notified and are looking into it.</p>
      <button
        onClick={() => window.location.reload()}
        style={{
          display: 'inline-block',
          margin: '1.5rem 0 0.75rem',
          padding: '0.75rem 2rem',
          fontSize: '1rem',
          fontWeight: 600,
          color: '#fff',
          backgroundColor: '#007b96',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Refresh page
      </button>
      <p>
        Or{' '}
        <a style={{ color: '#007b96' }} href="/">
          return to the home page
        </a>
      </p>
      {process.env.NODE_ENV === 'development' && <pre style={{ textAlign: 'left' }}>{error?.toString()}</pre>}
    </div>
  );
}

export default AppCrashFallback;
